<!-- Input para email

//utilização:
  <input-email
    v-on:update="updateCep"
    name="email"
    v-model="entity.part.email"
    v-validate="{numeric: true, min: 2, max: 15}"></input-email>

//eventos emit
v-on:update

-->

<template>
    <input
      type="text"
      :name="name"
      v-on:focus="selectAll"
      v-bind:value="email"
      v-on:input="updateValue($event.target.value)"
      v-on:blur="handleValidateEmail"
      ref="email"
      @keydown.enter="focusControl"
      >
</template>

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

import { SysVars } from '../main';
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      'value': String,
      'name': String
    },

    data () {
      return {
        email: this.value,
        fucused: false
      }
    },
    created () {

    },

    watch: {
      value: function (newValue) {
        this.email = newValue
      }
    },

    methods: {

      updateValue: function(value) {
        this.email = value.toLowerCase()
        this.$emit('input', this.email)
      },

      handleValidateEmail: function() {
        if (!this.email) {
          return
        }
        if (!this.$isValidEmail(this.email)) {
          this.focus()
        }
      },

      selectAll: function(event) {
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.email) {
              this.$refs.email.focus()
          }
      },

    },

}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-email.vue